import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import jmoment from 'moment-jalaali';
import UiButton from 'ui-components/ui-button/UiButton';
import { magicNumbers } from 'utils';
import {
  getToOneMonthDuration,
  getMoreThanOneMonthDurations,
  getLessThanOneDayDurationsFiltered,
} from './durations';

/**
 * کامپوننت مربوط به بخش انتخاب بازه زمانی
 * @returns
 */
export function TimeDuration(props) {
  const { minDate, selectedTimeDuration, onTimeDurationChange } = props;
  const pathname = window?.location?.pathname;
  const [timeDurations, setTimeDurations] = useState([]);

  const diff = jmoment(jmoment()).diff(
    jmoment().subtract(
      minDate?.fromNow || magicNumbers.LAST_FORTY_DAYS,
      minDate?.unit || 'days'
    ),
    'days'
  );

  useEffect(() => {
    if (pathname?.includes('ecommerce/reviews-table')) {
      setTimeDurations([
        ...getToOneMonthDuration(),
        ...getMoreThanOneMonthDurations(),
      ]);
      return;
    }

    let durations =
      pathname?.includes('brandbaan') || pathname?.includes('ecommerce')
        ? getLessThanOneDayDurationsFiltered()
        : getToOneMonthDuration();
    const shouldDisplayMoreThanOneMonth =
      pathname?.includes('contents') || diff > magicNumbers.LAST_FORTY_DAYS;

    if (shouldDisplayMoreThanOneMonth) {
      durations = [...durations, ...getMoreThanOneMonthDurations()];
    }
    setTimeDurations(durations);
  }, [diff, pathname]);

  return (
    <div className='time-durations flex'>
      {timeDurations.map((duration) => {
        return (
          <UiButton
            variant='outlined'
            color={
              duration.time_duration === selectedTimeDuration
                ? 'primary'
                : 'default'
            }
            key={duration.key}
            onClick={() => onTimeDurationChange(duration)}
            data-testid={`${props?.['data-testid']}-time-duration-${duration.time_duration}`}
          >
            {duration.key}
          </UiButton>
        );
      })}
    </div>
  );
}

TimeDuration.propTypes = {
  onTimeDurationChange: PropTypes.func,
  minDate: PropTypes.any,
  selectedTimeDuration: PropTypes.string,
  'data-testid': PropTypes.string,
};
